import type { KycVerificationSiteSettings } from '../../kycVerification.types.ts';

const KYC_VERIFICATION: KycVerificationSiteSettings = {
  methods: [
    {
      name: 'UK document identity verification',
      stepId: 'jumio',
      icon: 'DrivingLicense',
      translationKey: 'driving_licence',
      dataTrackName: 'Driving Licence',
    },
    {
      name: 'manual-upload',
      stepId: 'manual-upload',
      icon: 'Passport',
      translationKey: 'manual_upload',
      dataTrackName: 'Passport And Utility Bill',
    },
  ],
};

export { KYC_VERIFICATION };
